module.exports = "https://static.wmbcdn.com/uniweb/images/02503218ebb98f6fd3c8426586003069.svg";